@if (error) {
  <div class="err-global-msg-box mob_padd">
    <div class="err-golbal-content">
      @for (err of errorArray; track err) {
        <div>
          @if (err) {
            <span [innerHTML]='err|updateValue'></span>
          }
        </div>
      }
    </div>
    <div class="closer" (click)="error = !error">x</div>
  </div>
}
<div class="row col-12 col-sm-12 my-account-container" [ngClass]="isMobile? 'px-0':'pr-0'">
  @if (!isMobile) {
    <div class="col-3 col-sm-3 my-account-left-nav">
      <app-my-account-left-sidenav [navState]="'MyOwnPartNavNode'"></app-my-account-left-sidenav>
    </div>
  }
  <div class="myAccountMyProfile col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav"
    [ngClass]="isMobile? 'col-12' :'col-9 col-sm-9'">
    <h1 class="myProfileTopHeader m-0">
      {{'common.text_account_myPart_updatePersonalDetails'|cxTranslate}}
    </h1>
    <div class="myProfileBody myownpartnumberbody">
      <p class="ownpartTitle"><b>{{'common.text_account_myPart_updatePersonalDetails'|cxTranslate}}</b></p>
      <cx-page-slot class="fs-20" position="customerMypartNumberSlot"></cx-page-slot>
      @if (customerId$|async; as customerID ) {
        <app-customer-id-drop-down [customerId]="customerID.b2bUnitsWSList | unselect" [pageSource]="pageSource"
        (childValue)="onChildValue($event)"></app-customer-id-drop-down>
      }
      <div class="myProfileButtonContainer mt-3">
        <div class="row myownpart-number-btnblock" [ngClass]="isMobile ?'m-0':''">
          <div class="col-12 col-sm-6 col-md-6 mb-3 mb-md-0 download_btn_div" [ngClass]="isMobile ?'':''">
            <a (click)="downloader()" download="OrderTemplate.csv"
              class="btn action-button btn-block centering f-18-btn">{{'common.text_account_myPart_download_button'|cxTranslate}}
              <img src="/icons/link-dark-grey.svg" style="width: 35px;" class="whiteArrow" alt="Link Icon">
            </a>
          </div>
          <div class="col-12 col-sm-6 col-md-6 update-mypartnumber" [ngClass]="isMobile ?'':''">
            <div class="form-group file-upload js-file-upload">
              <div class="file-upload__wrapper btn action-button centering btn-block" id="chooseFileButton">
                <span class="f-18-btn">{{'common.text_account_myPart_upload_button'|cxTranslate}}</span>
                <img src="/icons/link-dark-grey.svg" style="width: 35px;" class="whiteArrow"
                  alt="Link Icon">
                  <input (click)="checkcustIdSelected($event)" type="file" id="csvFile" name="csvFile"
                    #fileInput class="file-upload__input js-file-upload__input "
                    (input)="onFileSelected(fileInput)" accept=".xls,.xlsx,.csv">
                  </div>
                  @if (isCustomerSelected) {
                    <span
                    class="errtext">{{'common.text_account_myPart_select_customer'|cxTranslate}}</span>
                  }
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>